import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6" data-testid="payment-cancel-screen">
      <div className="max-w-md w-full card-obsidian p-8 text-center">
        <div className="flex items-center justify-center mb-6"><BrandLogo /></div>
        <XCircle className="w-14 h-14 text-slate-400 mx-auto mb-4" />
        <h1 className="text-2xl font-serif font-medium mb-2">Pago cancelado</h1>
        <p className="text-sm text-slate-500">No se realizó ningún cargo. Puedes suscribirte cuando quieras.</p>
        <Button data-testid="cancel-go-plans" onClick={() => navigate("/portal/planes")} className="mt-6 gold-gradient-bg text-white font-semibold rounded-full w-full">
          Volver a planes
        </Button>
      </div>
    </div>
  );
}
